export type Daypart = 'morning' | 'day' | 'evening' | 'night';

/** Local time, deliberately: the companion should feel like evening when it
 *  is evening where the user is, not in UTC. */
export function daypartAt(date: Date): Daypart {
  const hour = date.getHours();
  if (hour >= 5 && hour < 12) return 'morning';
  if (hour >= 12 && hour < 18) return 'day';
  if (hour >= 18 && hour < 23) return 'evening';
  return 'night';
}
